export default {
  svgPath: `
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4.375 11.719l1.25 1.562L10 9.78l4.375 3.5 1.25-1.562L10 7.219l-5.625 4.5z"/>
  `,
  title: 'Chrevron Up',
  viewBox: '0 0 20 20',
};

